import React, { useState, useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import logo from '../assets/imgs/DigitalContacts-logo.svg';
import { sendCodeToEmail } from '../actions/resetPassword';

const Reset = ({ sendCodeToEmail, emailFound, error }) => {
  useEffect(() => {
    if (error) {
      setloading(false);
      alert(error);
    }
  }, [error]);
  const [email, setemail] = useState();
  const [loading, setloading] = useState(false);
  // Deliberately not gated on isAuth. Someone signed in who wants to
  // reset their password should simply be able to -- and since the
  // emailed reset link is tapped on a phone, which is exactly the device
  // they are already signed in on, the signed-in case is the *primary*
  // path for this flow rather than an edge case.
  //
  // Being signed in confers nothing here: the code is emailed to the
  // address on the account and POST /code_check matches on email plus
  // code, so a signed-in visitor can no more reset someone else's
  // password than a logged-out one can.
  if (emailFound) {
    return <Redirect to='/enter_code' />;
  }

  return (
    <div class='my-name create-account wel-back'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='login1'>
              <Link to='login' className='account1'>
               Got your card?
              </Link>
              <Link to='login' className='log-in'>
                login
              </Link>
            </div>
            <div className='logo'>
              <Link to='/login'>
                <img src={logo} alt='logo' />
              </Link>
            </div>
            <form
              id='sendOtp'
              onSubmit={(e) => {
                e.preventDefault();
                setloading(true);
                sendCodeToEmail(email);
              }}
            >
              <h1>Send 6 digit code</h1>
              <p className='p1'>
                Enter the email address associated with your account, and we’ll
                email you a 6 digit code to reset your password.
              </p>
              <input
                type='email'
                name='email'
                id='iEmail'
                placeholder='Email address'
                required
                value={email}
                onChange={(e) => setemail(e.target.value)}
              />
              <button
                className='btn w-100prc'
                disabled={loading}
                id='submitBtnSendOtp'
              >
                {loading ? 'loading...' : 'Send 6 digit code'}
              </button>
            </form>
            <Link to='/find_account' className='forgot'>
              Don't remember which email you used?
            </Link>
            {/* <Link to="login" className="forgot">
              Back to Login?
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.registerUser.loading,
  emailFound: state.resetPassword.emailFound,
  error: state.resetPassword.error,
});

export default connect(mapStateToProps, { sendCodeToEmail })(Reset);
